export default __webpack_public_path__ + "static/hilly-category-b57f0fc8c0102e5dcbdf1619f4f20d55.webp";